import React, { useState } from "react";
import {
  Row,
  Col,
  Container,
  Form,
  Button,
  Alert,
  Spinner,
  Card,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

// Import auth service
import { adminAuthService } from "../../../services/api";

//img
import rsLogo from "../../../assets/images/rs_logo.png";

const AdminLogin = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("danger");
  const [validated, setValidated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    setIsLoading(true);

    try {
      // Call the admin login API
      await adminAuthService.login(formData.username, formData.password);

      // Successful login
      setAlertVariant("success");
      setAlertMessage("เข้าสู่ระบบแอดมินสำเร็จ กำลังนำคุณไปยังหน้าแดชบอร์ด");
      setShowAlert(true);

      // Redirect after a short delay
      setTimeout(() => {
        navigate("/admin/dashboard");
      }, 1000);
    } catch (error) {
      // Failed login - handle specific error codes from API
      let errorMsg = "เข้าสู่ระบบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง";

      if (error.response?.data) {
        const errorData = error.response.data;

        // Check for specific unauthorized messages
        if (typeof errorData === 'string') {
          if (errorData.includes('Unauthorized #01')) {
            errorMsg = "ไม่พบชื่อผู้ใช้นี้ในระบบ";
          } else if (errorData.includes('Unauthorized #02')) {
            errorMsg = "รหัสผ่านไม่ถูกต้อง";
          } else if (errorData.includes('Unauthorized #03')) {
            errorMsg = "บัญชีของคุณถูกระงับการใช้งาน";
          } else if (errorData.includes('Unauthorized #04')) {
            errorMsg = "คุณไม่มีสิทธิ์เข้าถึงระบบแอดมิน";
          } else {
            errorMsg = errorData;
          }
        } else if (errorData.message) {
          errorMsg = errorData.message;
        }
      }

      setAlertVariant("danger");
      setAlertMessage(errorMsg);
      setShowAlert(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <section className="sign-in-page" style={{ minHeight: "100vh", display: "flex", alignItems: "center" }}>
        <Container>
          <Row className="justify-content-center">
            <Col md={6} lg={5}>
              <Card className="shadow-lg">
                <Card.Body className="p-5">
                  <div className="text-center mb-4">
                    <Link
                      to="/"
                      className="d-inline-flex align-items-center justify-content-center gap-2"
                    >
                      <img
                        src={rsLogo}
                        alt="RS Logo"
                        width="50"
                        className="img-fluid"
                      />
                      <h2 className="logo-title mb-0">Ruaysure Admin</h2>
                    </Link>
                    <p className="mt-3 text-muted">เข้าสู่ระบบแอดมิน</p>
                  </div>

                  {showAlert && (
                    <Alert
                      variant={alertVariant}
                      className="mb-4"
                      onClose={() => setShowAlert(false)}
                      dismissible
                    >
                      {alertMessage}
                    </Alert>
                  )}

                  <Form
                    noValidate
                    validated={validated}
                    onSubmit={handleSubmit}
                  >
                    <Form.Group className="form-group mb-3">
                      <Form.Label className="fw-bold">Username</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="ชื่อผู้ใช้แอดมิน"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        กรุณากรอกชื่อผู้ใช้
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="form-group mb-3">
                      <Form.Label className="fw-bold">Password</Form.Label>
                      <Form.Control
                        type="password"
                        placeholder="รหัสผ่าน"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        กรุณากรอกรหัสผ่าน
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Button
                      variant="primary"
                      type="submit"
                      className="w-100 mt-3 fw-semibold"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-2"
                          />
                          กำลังเข้าสู่ระบบ...
                        </>
                      ) : (
                        "เข้าสู่ระบบ"
                      )}
                    </Button>

                    <div className="text-center mt-4">
                      <Link to="/login" className="text-muted">
                        ← กลับไปหน้าเข้าสู่ระบบสำหรับลูกค้า
                      </Link>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AdminLogin;
